export default __webpack_public_path__ + "static/media/Gallery9.3f89f400.jpg";